<template>
    <div class="step3-container"> 
        <div v-if="form.pricings.length"
             class="step">
            <camp-pricing-end v-for="(pricing, index) of form.pricings"
                              :key="index"
                              class="camp-pricing"
                              :pricing="pricing"
                              :new-pricing="pricing.new"
                              @input:price="setPricingPrice({ price: $event, id: pricing.id })"
                              @input:wait-list="setPricingWaitList({ waitList: $event, id: pricing.id })"
                              @input:max-wait-list="setPricingMaxWaitList({ maxWaitList: $event, id: pricing.id })"
                              @input:max-enroll="setPricingMaxEnroll({ maxEnroll: $event, id: pricing.id }) "
                              @input:billing-type="setPricingBillingType({ billingType: $event, id: pricing.id })"
                              @input:paid="setPricingPaid({ paid: $event, id: pricing.id })">
            </camp-pricing-end>
        </div>
        <!-- <div class="step step-closed">
            <div class="d-flex justify-content-between align-items-center">
                <h2>Is there any prorating?</h2>
                <switch-button id="prorate"
                               v-bind:checked.sync="prorate">
                </switch-button>
            </div>
        </div> -->
        <div v-if="hasAtLeastOnePaidPricing" :class="{'step-closed': !discountsOpened ,'disabled': isCampCostEditingDisabled }"
             class="step">
            <div class="d-flex justify-content-between align-items-center">
                <h2>Are there any discounts?</h2>
                <switch-button id="discount-opened"
                               v-bind:checked.sync="discountsOpened">
                </switch-button>
            </div>
            <template v-if="detectIE">
                <transition name="expand">
                    <div v-if="discountsOpened"
                         class="mg-top-40">
                         <div class="d-flex">
                            <div class="discount-row-item">
                                <switch-button id="early-bird-discount-active-ie"
                                               label="Early bird"
                                               v-bind:checked.sync="earlyBirdActive">
                                </switch-button>
                            </div>
                            <div class="discount-row-item">
                                <select-box label="Type"
                                            key="earlyBirdBonusType"
                                            placeholder="Select $ or %"
                                            :disabled="!earlyBirdActive"
                                            :default-value="form.earlyBirdDiscount && form.earlyBirdDiscount.bonusType"
                                            @selected="setEarlyBirdBonusType"
                                            :required="form.earlyBirdDiscount && form.earlyBirdDiscount.active && discountsOpened"
                                            :data-list="Object.values(BONUS_PAYMENTS_TYPES)">
                                </select-box>
                            </div>
                            <div class="discount-row-item">
                                <app-input id="earlyBirdAmount-ie"
                                           label="Amount Off"
                                           placeholder="15"
                                           v-validate="{
                                             required: form.earlyBirdDiscount && form.earlyBirdDiscount.active && discountsOpened,
                                             percentage:  form.earlyBirdDiscount && form.earlyBirdDiscount.bonusType === BONUS_PAYMENTS_TYPES.RELATIVE,
                                             max: 15,
                                             decimal: 2,
                                            'bigger-or-equal': 0.01
                                       }"
                                           :disabled="!earlyBirdActive"
                                           :min-width=100
                                           name="earlyBirdAmount"
                                           key="earlyBirdAmount"
                                           v-model="earlyBirdAmount"
                                           type="text">
                                </app-input>
                            </div>
                            <div class="discount-row-item">
                                <date-picker id="ends-ie"
                                             class="discount-right-tooltiptext-ends"
                                             info="Select last date the discount is available"
                                             name="earlyBirdEnds"
                                             key="earkyBirdEnds"
                                             :min-width=100
                                             v-validate="{
                                            required: form.earlyBirdDiscount && form.earlyBirdDiscount.active && discountsOpened,
                                             'future-date': !validateCampEarlyBirdDiscountExeption
                                             }"
                                             :disabled="!earlyBirdActive"
                                             v-model="earlyBirdEndDate"
                                             label="Ends">
                                </date-picker>
                                <div class="position-relative">
                                    <div v-if="futureDate(earlyBirdEndDate)"
                                    class="error">Should be future date</div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="discount-row-item">
                                <switch-button id="multi-program-discount-active-ie"
                                               label="Multi program"
                                               v-bind:checked.sync="multiProgramDiscountActive">
                                </switch-button>
                            </div>
                            <div class="discount-row-item">
                                <select-box label="Type"
                                            key="multiProgram"
                                            placeholder="Select $ or %"
                                            :disabled="!multiProgramDiscountActive"
                                            :default-value="form.multiProgramDiscount && form.multiProgramDiscount.bonusType"
                                            :data-list="Object.values(BONUS_PAYMENTS_TYPES)"
                                            :required="form.multiProgramDiscount && form.multiProgramDiscount.active"
                                            @selected="setMultiProgramDiscountBonusType">
                                </select-box>
                            </div>
                            <div class="discount-row-item">
                                <app-input id="multiProgramDiscount-ie"
                                           key="multiProgramDiscount"
                                           placeholder="15"
                                           v-validate="{
                                            required: form.multiProgramDiscount && form.multiProgramDiscount.active,
                                            percentage: form.multiProgramDiscount && form.multiProgramDiscount.bonusType === BONUS_PAYMENTS_TYPES.RELATIVE,
                                            max: 15,
                                            decimal: 2,
                                            'bigger-or-equal': 0.01
                                       }"
                                           :disabled="!multiProgramDiscountActive"
                                           :min-width=100
                                           name="multiProgramAmount"
                                           v-model="multiProgramDiscountAmount"
                                           label="Amount Off"
                                           type="text">
                                </app-input>
                            </div>
                            <div class="discount-row-item">
                                <app-input id="multiProgramAfter-ie"
                                           class="discount-right-tooltiptext"
                                           info="Enter the number of camps a child <br> must be enrolled in to receive the discount"
                                           key="multiProgramAfter"
                                           placeholder="2"
                                           :disabled="!multiProgramDiscountActive"
                                           :min-width=100
                                           v-validate="{
                                            required: form.multiProgramDiscount && form.multiProgramDiscount.active,
                                            numeric: true,
                                            max: 9
                                            }"
                                           name="multiProgramNumberOfKids"
                                           v-model="multiProgramDiscountNumberOfKids"
                                           label="Discount After"
                                           type="number">
                                </app-input>
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="discount-row-item">
                                <switch-button label="Multi child"
                                               id="multi-child-discount-active-ie"
                                               v-bind:checked.sync="multiChildDiscountActive">
                                </switch-button>
                            </div>
                            <div class="discount-row-item">
                                <div class="mt-auto">
                                 <select-box label="Type"
                                            key="multiChildDiscount"
                                            placeholder="Select $ or %"
                                            :disabled="!multiChildDiscountActive"
                                            :default-value="form.multiChildDiscount && form.multiChildDiscount.bonusType"
                                            :data-list="Object.values(BONUS_PAYMENTS_TYPES)"
                                            :required="form.multiChildDiscount && form.multiChildDiscount.active && discountsOpened"
                                            @selected="setMultiChildDiscountBonusType">
                                 </select-box>
                                </div>
                            </div>
                            <div class="discount-row-item">
                                <app-input id="siblingAmount-ie"
                                           key="multiChildDiscountAmount"
                                           placeholder="15"
                                           :disabled="!multiChildDiscountActive"
                                           :min-width=100
                                           v-validate="{
                                            required: form.multiChildDiscount && form.multiChildDiscount.active && discountsOpened,
                                            percentage: form.multiChildDiscount && form.multiChildDiscount.bonusType === BONUS_PAYMENTS_TYPES.RELATIVE,
                                            max: 15,
                                            decimal: 2,
                                            'bigger-or-equal': 0.01
                                       }"
                                           name="siblingAmount"
                                           v-model="multiChildDiscountAmount"
                                           label="Amount Off"
                                           type="text">
                                </app-input>
                            </div>
                            <div class="discount-row-item">
                                <app-input id="after-ie"
                                           class="discount-right-tooltiptext"
                                           key="multiChildDiscountAfter"
                                           placeholder="2"
                                           info="Enter the number of children that need to be<br> enrolled in this camp to receive the discount."
                                           v-validate="{
                                                required: form.multiChildDiscount && form.multiChildDiscount.active && discountsOpened,
                                                numeric: true,
                                                max:9
                                                }"
                                           :disabled="!multiChildDiscountActive"
                                           :min-width=100
                                           name="siblingNumberOfKids"
                                           v-model="multiChildDiscountNumberOfKids"
                                           label="Discount After"
                                           type="number">
                                </app-input>
                            </div>
                        </div>
                        <!-- <div v-if="multiChildDiscountActive" 
                            class="checkbox__input">
                            <input 
                                type="checkbox" 
                                id="primary" 
                                v-model="multiChildDiscountFirstChild">
                            <label 
                                for="primary">
                                Apply multi-child discount to all children
                            </label>
                        </div> -->
                    </div>
                </transition>
            </template>
            <template v-else>
                <transition name="expand"
                            @enter="onEnter"
                            @after-enter="onAfterEnter"
                            @leave="onLeave">
                    <div v-if="discountsOpened"
                         class="mg-top-40">
                         <div class="discount-wrapper">
                            <div class="discount-row-item">
                                <switch-button id="early-bird-discount-active"
                                               label="Early bird"
                                               v-bind:checked.sync="earlyBirdActive">
                                </switch-button>
                            </div>
                            <div class="discount-row-item">
                                <select-box label="Type"
                                            key="earlyBirdBonusType"
                                            placeholder="Select $ or %"
                                            :disabled="!earlyBirdActive"
                                            :default-value="form.earlyBirdDiscount && form.earlyBirdDiscount.bonusType"
                                            @selected="setEarlyBirdBonusType"
                                            :required="form.earlyBirdDiscount && form.earlyBirdDiscount.active && discountsOpened"
                                            :data-list="Object.values(BONUS_PAYMENTS_TYPES)">
                                </select-box>
                            </div>
                            <div class="discount-row-item">
                                <app-input id="earlyBirdAmount"
                                           label="Amount Off"
                                           placeholder="15"
                                           v-validate="{
                                             required: form.earlyBirdDiscount && form.earlyBirdDiscount.active && discountsOpened,
                                             percentage:  form.earlyBirdDiscount && form.earlyBirdDiscount.bonusType === BONUS_PAYMENTS_TYPES.RELATIVE,
                                             max: 15,
                                             decimal: 2,
                                            'bigger-or-equal': 0.01
                                       }"
                                           :disabled="!earlyBirdActive"
                                           name="earlyBirdAmount"
                                           key="earlyBirdAmount"
                                           v-model="earlyBirdAmount"
                                           type="text">
                                </app-input>
                            </div>
                            <div class="discount-row-item" style="position: relative;">
                                <date-picker id="ends"
                                             class="discount-right-tooltiptext-ends"
                                             info="Select last date the discount is available"
                                             name="earlyBirdEnds"
                                             key="earkyBirdEnds"
                                             v-validate="{
                                            required: form.earlyBirdDiscount &&form.earlyBirdDiscount.active && discountsOpened,
                                             'future-date': !validateCampEarlyBirdDiscountExeption
                                             }"
                                             :disabled="!earlyBirdActive"
                                             v-model="earlyBirdEndDate"
                                             label="Ends">
                                </date-picker>
                                
                                    <div v-if="futureDate(earlyBirdEndDate)"
                                    class="error" style="top: 70px;">Should be future date</div>
                                
                            </div>
                        </div>
                        <div class="discount-wrapper">
                            <div class="discount-row-item">
                                <switch-button label="Multi child"
                                               id="multi-child-discount-active"
                                               v-bind:checked.sync="multiChildDiscountActive">
                                </switch-button>
                            </div>
                            <div class="discount-row-item">
                                <div class="mt-auto">
                                    <select-box label="Type"
                                            key="multiChildDiscount"
                                            placeholder="Select $ or %"
                                            :disabled="!multiChildDiscountActive"
                                            :default-value="form.multiChildDiscount && form.multiChildDiscount.bonusType"
                                            :data-list="Object.values(BONUS_PAYMENTS_TYPES)"
                                            :required="form.multiChildDiscount && form.multiChildDiscount.active && discountsOpened"
                                            @selected="setMultiChildDiscountBonusType">
                                    </select-box>
                                </div>
                            </div>
                            <div class="discount-row-item">
                                <app-input id="siblingAmount"
                                           key="multiChildDiscountAmount"
                                           placeholder="15"
                                           :disabled="!multiChildDiscountActive"
                                           v-validate="{
                                            required: form.multiChildDiscount && form.multiChildDiscount.active && discountsOpened,
                                            percentage: form.multiChildDiscount && form.multiChildDiscount.bonusType === BONUS_PAYMENTS_TYPES.RELATIVE,
                                            max: 15,
                                            decimal: 2,
                                            'bigger-or-equal': 0.01
                                       }"
                                           name="siblingAmount"
                                           v-model="multiChildDiscountAmount"
                                           label="Amount Off"
                                           type="text">
                                </app-input>
                            </div>
                            <div class="discount-row-item">
                                <app-input id="after"
                                           class="discount-right-tooltiptext"
                                           key="multiChildDiscountAfter"
                                           placeholder="2"
                                           info="Enter the number of children that need to be<br> enrolled in this camp to receive the discount."
                                           v-validate="{
                                                required: form.multiChildDiscount && form.multiChildDiscount.active && discountsOpened,
                                                numeric: true,
                                                max:9
                                                }"
                                           :disabled="!multiChildDiscountActive"
                                           name="siblingNumberOfKids"
                                           v-model="multiChildDiscountNumberOfKids"
                                           label="Discount After"
                                           type="number">
                                </app-input>
                            </div>
                        </div>
                        <div class="discount-wrapper">
                            <div class="discount-row-item">
                                <switch-button id="multi-program-discount-active"
                                               label="Multi program"
                                               v-bind:checked.sync="multiProgramDiscountActive">
                                </switch-button>
                            </div>
                            <div class="discount-row-item">
                                <select-box label="Type"
                                            key="multiProgram"
                                            placeholder="Select $ or %"
                                            :disabled="!multiProgramDiscountActive"
                                            :default-value="form.multiProgramDiscount && form.multiProgramDiscount.bonusType"
                                            :data-list="Object.values(BONUS_PAYMENTS_TYPES)"
                                            :required="form.multiProgramDiscount && form.multiProgramDiscount.active"
                                            @selected="setMultiProgramDiscountBonusType">
                                </select-box>
                            </div>
                            <div class="discount-row-item">
                                <app-input id="multiProgramDiscount"
                                           key="multiProgramDiscount"
                                           placeholder="15"
                                           v-validate="{
                                            required: form.multiProgramDiscount && form.multiProgramDiscount.active,
                                            percentage: form.multiProgramDiscount && form.multiProgramDiscount.bonusType === BONUS_PAYMENTS_TYPES.RELATIVE,
                                            max: 15,
                                            decimal: 2,
                                            'bigger-or-equal': 0.01
                                       }"
                                           :disabled="!multiProgramDiscountActive"
                                           name="multiProgramAmount"
                                           v-model="multiProgramDiscountAmount"
                                           label="Amount Off"
                                           type="text">
                                </app-input>
                            </div>
                            <div class="discount-row-item">
                                <app-input id="multiProgramAfter"
                                           class="discount-right-tooltiptext"
                                           info="Enter the number of camps a child <br> must be enrolled in to receive the discount"
                                           key="multiProgramAfter"
                                           placeholder="2"
                                           :disabled="!multiProgramDiscountActive"
                                           v-validate="{
                                            required: form.multiProgramDiscount && form.multiProgramDiscount.active,
                                            numeric: true,
                                            max: 9
                                            }"
                                           name="multiProgramNumberOfKids"
                                           v-model="multiProgramDiscountNumberOfKids"
                                           label="Discount After"
                                           type="number">
                                </app-input>
                            </div>
                        </div>
                        <!-- <div v-if="multiChildDiscountActive" 
                            class="checkbox__input">
                            <input 
                                type="checkbox" 
                                id="primary" 
                                v-model="multiChildDiscountFirstChild">
                            <label 
                                for="primary">
                                Apply multi-child discount to all children
                            </label>
                        </div> -->
                    </div>
                </transition>
            </template>
        </div>
        <div :class="{'step-closed': !addOnsOpened,'disabled': isCampCostEditingDisabled}"
             class="step">
            <div class="d-flex justify-content-between align-items-center">
                <h2>Are there any add-ons?</h2>
                <switch-button id="addons-opened"
                               v-bind:checked.sync="addOnsOpened">
                </switch-button>
            </div>
            <template v-if="detectIE">
                <transition name="expand">
                    <div v-if="addOnsOpened"
                         class="mg-top-40">
                        <add-on v-for="addOn of addOns"
                                :key="addOn.id"
                                :add-on="addOn"
                                :required="addOnsOpened"
                                @remove="removeAddOn(addOn.id)"
                                @input:name="setAddOnName({name: $event, id: addOn.id})"
                                @input:price="setAddOnPrice({price: $event, id: addOn.id})"
                                @input:required="setAddOnRequired({required: $event, id: addOn.id})"
                                @input:max-amount="setAddOnMaxAmount({maxAmount: $event, id: addOn.id})"
                        >
                        </add-on>
                        <add-button @click="addNewAddOn"
                                    class="add-button">
                            Addon
                        </add-button>
                    </div>
                </transition>
            </template>
            <template v-else>
                <transition name="expand"
                            @enter="onEnter"
                            @after-enter="onAfterEnter"
                            @leave="onLeave">
                    <div v-if="addOnsOpened"
                         class="mg-top-40">
                        <add-on v-for="addOn of addOns"
                                :key="addOn.id"
                                :add-on="addOn"
                                :required="addOnsOpened"
                                @remove="removeAddOn(addOn.id)"
                                @input:name="setAddOnName({name: $event, id: addOn.id})"
                                @input:price="setAddOnPrice({price: $event, id: addOn.id})"
                                @input:required="setAddOnRequired({required: $event, id: addOn.id})"
                                @input:max-amount="setAddOnMaxAmount({maxAmount: $event, id: addOn.id})"
                        >
                        </add-on>
                        <add-button @click="addNewAddOn"
                                    class="add-button">
                            Addon
                        </add-button>
                    </div>
                </transition>
            </template>
        </div>
        <div :class="{'step-closed': !detailsOpened}"
             class="step">
            <div class="d-flex justify-content-between align-items-center">
                <h2>Are other details needed?</h2>
                <switch-button id="details-opened"
                               v-bind:checked.sync="detailsOpened">
                </switch-button>
            </div>
            <template v-if="detectIE">
                <transition name="expand">
                    <div v-if="detailsOpened"
                         class="mg-top-40 mg-right-150">
                        <div class="mg-top-40">
                            <select-box
                                label="Choose question form"
                                :multiple-select="true"
                                :chip-width="chipWidth"
                                :show-all-item="false"
                                :data-list="customForms"
                                :format-callback="form => form.formName"
                                :default-value="defaultCustomForms"
                                :required="false"
                                @selected="selectedForm($event)">
                            </select-box>
                        </div>
                        <div class="d-flex justify-content-between">
                            <checkbox v-bind:checked.sync="pickUpOptions"
                                      class="step3-checkbox">
                                Pickup Options
                            </checkbox>
                            <checkbox v-bind:checked.sync="pickUpOptionsRequired"
                                      :disabled="!pickUpOptions"
                                      class="step3-checkbox">
                                Required
                            </checkbox>
                        </div>
                        <div class="d-flex justify-content-between">
                            <checkbox v-bind:checked.sync="teacher"
                                      class="step3-checkbox">
                                Homeroom Teacher
                            </checkbox>
                            <checkbox v-bind:checked.sync="teacherRequired"
                                      :disabled="!teacher"
                                      class="step3-checkbox">
                                Required
                            </checkbox>
                        </div>
                        <div class="d-flex justify-content-between">
                            <checkbox v-bind:checked.sync="tshirt">
                                T-shirt size
                            </checkbox>
                            <checkbox v-bind:checked.sync="tshirtRequired"
                                      :disabled="!tshirt">
                                Required
                            </checkbox>
                        </div>
                    </div>
                </transition>
            </template>
            <template v-else>
                <transition name="expand"
                            @enter="onEnter"
                            @after-enter="onAfterEnter"
                            @leave="onLeave">
                    <div v-if="detailsOpened"
                         class="mg-top-40 mg-right-150">
                        <div class="mg-top-40">
                            <select-box
                                label="Choose question form"
                                :multiple-select="true"
                                :chip-width="chipWidth"
                                :show-all-item="false"
                                :data-list="customForms"
                                :format-callback="form => form.formName"
                                :default-value="defaultCustomForms"
                                :required="false"
                                @selected="selectedForm($event)">
                            </select-box>
                        </div>
                        <div class="d-flex justify-content-between">
                            <checkbox v-bind:checked.sync="pickUpOptions"
                                      class="step3-checkbox">
                                Pickup Options
                            </checkbox>
                            <checkbox v-bind:checked.sync="pickUpOptionsRequired"
                                      :disabled="!pickUpOptions"
                                      class="step3-checkbox">
                                Required
                            </checkbox>
                        </div>
                        <div class="d-flex justify-content-between">
                            <checkbox v-bind:checked.sync="teacher"
                                      class="step3-checkbox">
                                Homeroom Teacher
                            </checkbox>
                            <checkbox v-bind:checked.sync="teacherRequired"
                                      :disabled="!teacher"
                                      class="step3-checkbox">
                                Required
                            </checkbox>
                        </div>
                        <div class="d-flex justify-content-between">
                            <checkbox v-bind:checked.sync="tshirt">
                                T-shirt size
                            </checkbox>
                            <checkbox v-bind:checked.sync="tshirtRequired"
                                      :disabled="!tshirt">
                                Required
                            </checkbox>
                        </div>
                    </div>
                </transition>
            </template>
        </div>
    </div>
</template>

<script>
    import {ExpandAnimationMixin} from '@/mixins/expandAnimationMixin';
    import * as Mutations from '@/store/modules/camp-form/mutations';
    import {mapActions, mapGetters, mapMutations} from 'vuex';
    import moment from 'moment';
    import {capitalize} from '@/common/utils/strings';
    import * as BONUS_PAYMENTS_TYPES from '@/constants/bonus-payment-types';
    import {FormMixin} from '@/mixins/FormMixin';

    const PAY_TYPES = ['Free', 'Paid'];

    export default {
        name: 'Step3',
        components: {
            CampPricingEnd: () => import(/* webpackChunkName: 'camps' */ './CampPricingEnd'),
            AddOn:          () => import(/* webpackChunkName: 'camps' */ './AddOn'),
            Dropdown: () => import('@/components/controls/Dropdown'),
            AddButton:      () => import('../../../controls/AddButton'),
            SelectBox:      () => import('../../../controls/SelectBox'),
            Checkbox:       () => import('../../../controls/Checkbox'),
            SwitchButton:   () => import('../../../controls/SwitchButton'),
            NumberPeel:     () => import('../../../controls/NumberPeel'),
            AppInput:       () => import('../../../controls/AppInput'),
            DatePicker:     () => import('../../../controls/DatePicker'),
            DayPicker:      () => import('../../../controls/DayPicker'),
            TimePicker:     () => import('../../../controls/TimePicker'),
            Choice:         () => import('../../../controls/Choice'),
        },
        mixins: [ExpandAnimationMixin, FormMixin],
        data() {
            return {
                PAY_TYPES,
                BONUS_PAYMENTS_TYPES,
                capitalize,
                formsList: [],
                defaultCustomForms: [],
                pricingTypes: []
            }
        },
        watch: {
            formValid: {
                handler() {
                    this.setValid(this.formValid);
                },
                immediate: true
            },
            campFormAddOnsOpened(value) {
                if (value && !this.form.addOns.length) {
                    this.addNewAddOn();
                }
            },
            detailsOpened: {
                handler(value) {
                    if (!value) {
                        this.pickUpOptions = false;
                        this.teacher = false;
                        this.tshirt = false;
                        this.form.camp.formIds = [];
                        this.defaultCustomForms = [];
                    }
                },
                immediate: true
            },
            discountsOpened: {
                handler(value) {
                    if (!value) {
                        this.multiChildDiscountActive = false;
                        this.multiProgramDiscountActive = false;
                        this.earlyBirdActive = false;
                    }
                },
                immediate: true
            },
            multiChildDiscountActive: {
                handler(value) {
                    if (!value) {
                        this.form.multiChildDiscount.bonusType = null;
                        this.form.multiChildDiscount.amount = null;
                        this.form.multiChildDiscount.after = null;
                        this.form.multiChildDiscount.familyType = false;
                    }
                },
                immediate: true
            },
            multiProgramDiscountActive: {
                handler(value) {
                    if (!value) {
                        this.form.multiProgramDiscount.bonusType = null;
                        this.form.multiProgramDiscount.amount = null;
                        this.form.multiProgramDiscount.after = null;
                    }
                },
                immediate: true
            },
            earlyBirdActive: {
                handler(value) {
                    if (!value) {
                        this.form.earlyBirdDiscount.bonusType = null;
                        this.form.earlyBirdDiscount.amount = null;
                        this.form.earlyBirdDiscount.endDate = null;
                    }
                },
                immediate: true
            },
        },
        computed: {
            ...mapGetters({
                form: 'campCreationForm',
                campFormDiscountsOpened: 'campFormDiscountsOpened',
                campFormAddOnsOpened: 'campFormAddOnsOpened',
                campFormDetailsOpened: 'campFormDetailsOpened',
                customForms: 'customForms',
                isCampCostEditingDisabled: 'isCampCostEditingDisabled',
                validateCampEarlyBirdDiscountExeption: 'validateCampEarlyBirdDiscountExeption',
            }),
            detectIE() {
                return window.navigator.userAgent.indexOf('MSIE') > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./);
            },
            addOns() {
                return this.form.addOns.filter(addOn => addOn.active);
            },
            teacher: {
                get() {
                    return this.form.camp.teacher;
                },
                set(value) {
                    this.setTeacher(value);
                    if (!value) {
                        this.teacherRequired = false;
                    }
                }
            },
            teacherRequired: {
                get() {
                    return this.form.camp.teacherRequired;
                },
                set(value) {
                    this.setTeacherRequired(value);
                }
            },
            tshirt: {
                get() {
                    return this.form.camp.tshirt;
                },
                set(value) {
                    this.setTShirt(value);
                    if (!value) {
                        this.tshirtRequired = false;
                    }
                }
            },
            tshirtRequired: {
                get() {
                    return this.form.camp.tshirtRequired;
                },
                set(value) {
                    this.setTShirtRequired(value);
                }
            },
            pickUpOptions: {
                get() {
                    return this.form.camp.pickUpOptions;
                },
                set(value) {
                    this.setPickUpOptions(value);
                    if (!value) {
                        this.pickUpOptionsRequired = false;
                    }
                }
            },
            pickUpOptionsRequired: {
                get() {
                    return this.form.camp.pickUpOptionsRequired;
                },
                set(value) {
                    this.setPickUpOptionsRequired(value);
                }
            },
            multiChildDiscountActive: {
                get() {
                    return this.form.multiChildDiscount && this.form.multiChildDiscount.active;
                },
                set(value) {
                    this.setMultiChildDiscountActive(value);
                }
            },
            multiChildDiscountBonusType: {
                get() {
                    return this.form.multiChildDiscount.bonusType;
                },
                set(value) {
                    this.setMultiChildDiscountBonusType(value);
                }
            },
            multiChildDiscountAmount: {
                get() {
                    return this.form.multiChildDiscount.amount;
                },
                set(value) {
                    this.setMultiChildDiscountAmount(value);
                }
            },
            multiChildDiscountNumberOfKids: {
                get() {
                    return this.form.multiChildDiscount.after;
                },
                set(value) {
                    this.setMultiChildDiscountNumberOfKids(value);
                }
            },
            multiChildDiscountFirstChild: {
                get() {
                    return this.form.multiChildDiscount.familyType;
                },
                set(value) {
                    this.setFirstChildDiscount(value);
                }
            },
            multiProgramDiscountActive: {
                get() {
                    return this.form.multiProgramDiscount && this.form.multiProgramDiscount.active;
                },
                set(value) {
                    this.setMultiProgramDiscountActive(value);
                }
            },
            multiProgramDiscountAmount: {
                get() {
                    return this.form.multiProgramDiscount.amount;
                },
                set(value) {
                    this.setMultiProgramDiscountAmount(value);
                }
            },
            multiProgramDiscountNumberOfKids: {
                get() {
                    return this.form.multiProgramDiscount.after;
                },
                set(value) {
                    this.setMultiProgramDiscountNumberOfKids(value);
                }
            },
            earlyBirdActive: {
                get() {
                    return this.form.earlyBirdDiscount && this.form.earlyBirdDiscount.active;
                },
                set(value) {
                    this.setEarlyBirdActive(value);
                }
            },
            earlyBirdAmount: {
                get() {
                    return this.form.earlyBirdDiscount.amount;
                },
                set(value) {
                    this.setEarlyBirdAmount(value);
                }
            },
            earlyBirdEndDate: {
                get() {
                    return this.form.earlyBirdDiscount.endDate;
                },
                set(value) {
                    this.setEarlyBirdEndDate(value);
                }
            },
            isFree() {
                return this.free ? PAY_TYPES[0] : PAY_TYPES[1];
            },
            discountsOpened: {
                get() {
                    return this.campFormDiscountsOpened;
                },
                set(value) {
                    this.setDiscountsOpened(value);
                }
            },
            addOnsOpened: {
                get() {
                    return this.campFormAddOnsOpened;
                },
                set(value) {
                    this.setAddOnsOpened(value);
                }
            },
            detailsOpened: {
                get() {
                    return this.campFormDetailsOpened;
                },
                set(value) {
                    this.setDetailsOpened(value);
                }
            },
            prorate: {
                get() {
                    return this.form.camp.prorate;
                },
                set(value) {
                    this.setProrate(value);
                }
            },
            chipWidth() {
                return window.innerWidth < 428 ? 185 : 135;
            },
            hasAtLeastOnePaidPricing() {
                return this.form.pricings && this.form.pricings.some(pricing => pricing.paid);
            },
        },
        methods: {
            ...mapMutations({
                setPrice: Mutations.CAMP_FORM_SET_PRICE,
                setProrate: Mutations.CAMP_FORM_SET_PRORATE,
                setTeacher: Mutations.CAMP_FORM_SET_TEACHER,
                setTeacherRequired: Mutations.CAMP_FORM_SET_TEACHER_REQUIRED,
                setTShirt: Mutations.CAMP_FORM_SET_T_SHIRT,
                setTShirtRequired: Mutations.CAMP_FORM_SET_T_SHIRT_REQUIRED,
                setPickUpOptions: Mutations.CAMP_FORM_SET_PICKUP_OPTIONS,
                setPickUpOptionsRequired: Mutations.CAMP_FORM_SET_PICKUP_OPTIONS_REQUIRED,
                setIntervalType: Mutations.CAMP_FORM_SET_INTERVAL_TYPE,
                setPricingPrice: Mutations.CAMP_FORM_SET_PRICING_PRICE,
                setPricingWaitList: Mutations.CAMP_FORM_SET_PRICING_WAITLIST,
                setPricingMaxWaitList: Mutations.CAMP_FORM_SET_PRICING_MAX_WAITLIST,
                setPricingMaxEnroll: Mutations.CAMP_FORM_SET_PRICING_MAX_ENROLL,
                setPricingBillingType: Mutations.CAMP_FORM_SET_PRICING_BILLING_TYPE,
                setPricingPaid: Mutations.CAMP_FORM_SET_PRICING_PAID,
                addNewAddOn: Mutations.CAMP_FORM_ADD_ADDON,
                setAddOnName: Mutations.CAMP_FORM_SET_ADDON_NAME,
                setAddOnPrice: Mutations.CAMP_FORM_SET_ADDON_PRICE,
                setAddOnRequired: Mutations.CAMP_FORM_SET_ADDON_REQUIRED,
                setAddOnDiscount: Mutations.CAMP_FORM_SET_ADDON_DISCOUNT,
                setAddOnMaxAmount: Mutations.CAMP_FORM_SET_ADDON_MAX_AMOUNT,
                removeAddOn: Mutations.CAMP_FORM_REMOVE_CAMP_ADDON,
                setMultiChildDiscountActive: Mutations.CAMP_FORM_SET_MULTI_CHILD_DISCOUNT_ACTIVE,
                setMultiChildDiscountBonusType: Mutations.CAMP_FORM_SET_MULTI_CHILD_DISCOUNT_BONUS_TYPE,
                setMultiChildDiscountAmount: Mutations.CAMP_FORM_SET_MULTI_CHILD_DISCOUNT_AMOUNT,
                setMultiChildDiscountNumberOfKids: Mutations.CAMP_FORM_SET_MULTI_CHILD_DISCOUNT_NUMBER_OF_KIDS,
                setFirstChildDiscount: Mutations.CAMP_FORM_SET_FIRST_CHILD_DISCOUNT,
                setMultiProgramDiscountActive: Mutations.CAMP_FORM_SET_MULTI_PROGRAM_DISCOUNT_ACTIVE,
                setMultiProgramDiscountBonusType: Mutations.CAMP_FORM_SET_MULTI_PROGRAM_DISCOUNT_BONUS_TYPE,
                setMultiProgramDiscountAmount: Mutations.CAMP_FORM_SET_MULTI_PROGRAM_DISCOUNT_AMOUNT,
                setMultiProgramDiscountNumberOfKids: Mutations.CAMP_FORM_SET_MULTI_PROGRAM_DISCOUNT_NUMBER_OF_KIDS,
                setEarlyBirdActive: Mutations.CAMP_FORM_SET_EARLY_BIRD_ACTIVE,
                setEarlyBirdBonusType: Mutations.CAMP_FORM_SET_EARLY_BIRD_BONUS_TYPE,
                setEarlyBirdAmount: Mutations.CAMP_FORM_SET_EARLY_BIRD_AMOUNT,
                setEarlyBirdEndDate: Mutations.CAMP_FORM_SET_EARLY_BIRD_END_DATE,
                setValid: Mutations.CAMP_FORM_SET_FORM_VALID,
                setAddOnsOpened: Mutations.CAMP_FORM_SET_ADDONS_OPENED,
                setDetailsOpened: Mutations.CAMP_FORM_SET_DETAILS_OPENED,
                setDiscountsOpened: Mutations.CAMP_FORM_SET_DISCOUNTS_OPENED,
            }),
            ...mapActions([
                'submitCampForm',
                'getCustomForms',
                'getAllCustomForms',
                'submitDraftCampForm'
            ]),
            futureDate(value) {
                return value && !moment(value).isAfter(moment(), 'days') && !this.isCampCostEditingDisabled;
            },
            clearValidationListener() {
                this.$root.$off('validate-camp-form');
                this.$root.$off('validate-camp-form-draft');
            },
            selectedForm(forms) {
                if (typeof forms === 'object') {
                    const idsList = [];
                    forms.forEach(el => {
                        idsList.push(el.id);
                    })
                    this.form.camp.formIds = idsList;
                }
            }
        },
        async created() {

            await this.getAllCustomForms();
            this.pricingTypes = this.form.pricings.map(pricing => pricing.price === 0 ? PAY_TYPES[0] : PAY_TYPES[1]);

            if (this.form.camp.formIds.length) {
                this.form.camp.formIds.forEach(el => {
                    const customElement = this.customForms.find(item => item.id === el);
                    this.defaultCustomForms.push(customElement);
                })
            }

            this.$root.$on('validate-camp-form', async () => {
                const isValid = await this.$validator.validateAll();
                if (isValid && !this.isSubmitted) {
                    this.submitCampForm();
                    this.isSubmitted = true;
                    this.clearValidationListener();
                }
            });
            this.$root.$on('validate-camp-form-draft', async (activateDraftForm) => {
                const isValid = await this.$validator.validateAll();
                if (isValid && !this.isSubmitted) {
                    this.submitDraftCampForm({
                        activateDraftForm
                    });
                    this.isSubmitted = true;
                    this.clearValidationListener();
                }
            });
        },
        beforeDestroy() {
            this.clearValidationListener();
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../../assets/colors";
    @import '../../../../assets/checkbox';

    .step3-container {
        display: flex;
        flex-direction: column;
        width: 100%;
        max-width: 100%;
    }

    .step {
        padding: 50px 92px 40px;
        background: $White;
        box-shadow: 0 0 20px 0 rgba(176, 186, 197, 0.15);
        margin-bottom: 50px;
        @media screen and (max-width: 1200px) {
            padding: 45px 50px 40px;
            &:nth-of-type(3) {
                padding: 40px 30px 30px;
            }
        }
        @media screen and (max-width: 991px) {
            padding: 40px 30px 30px;
        }
        @media screen and (max-width: 767px) {
            padding: 40px 20px 20px;
        }
        .mg-30 {
            margin-right: 30px;
        }
        .mg-top-40 {
            margin-top: 40px;
        }
        .mg-right-150 {
            padding-right: 150px;
            @media screen and (max-width: 767px) {
                padding-right: 10px;
            }
        }
        h2 {
            line-height: inherit;

            &:first-child {
                margin-bottom: 30px;
            }
            &:nth-of-type(2) {
                margin: 46px 0 32px;
            }
        }
        .d-flex h2 {
            margin-bottom: 0;
        }
        .day-picker {
            margin-bottom: 29px;
        }
        .delimetr {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 65px;
            font-family: Asap;
            font-size: 20px;
        }
        .step3-checkbox {
            margin-bottom: 22px;
        }
        .add-button {
            margin-top: 10px;
        }
        .discount-wrapper {
            display: flex;

            @media screen and (max-width: 680px) {
                flex-wrap: wrap;
                justify-content: space-between;
            }
        }
        .discount-row-item {
            flex: 0 0 25%;
            @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
                flex: none;
                width: 25%;
            }
            @media screen and (max-width: 680px) {
                flex-basis: 45%;
            }
            &:first-child {
                min-width: 91px;
                flex-basis: 15%;
                @media screen and (max-width: 1250px) {
                    flex-basis: 20%;
                }
                @media screen and (max-width: 680px) {
                    flex-basis: 30%;
                }
                @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
                    width: 15%;
                }
            }
            &:nth-child(2) {
                flex-basis: 35%;
                @media screen and (max-width: 1300px) {
                    flex-basis: 25%;
                }
                @media screen and (max-width: 680px) {
                    flex-basis: 65%;
                }
                @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
                    width: 35%;
                }
            }
            &:not(:first-child) {
                padding: 0 15px;
                @media screen and (max-width: 680px) {
                    padding: 0;
                }
            }
        }
    }
    .step-closed {
        padding-top: 15px !important;
        padding-bottom: 19px !important;
        h2 {
            margin-bottom: 0;
        }
    }
    .disabled {
            pointer-events: none;
            opacity: 0.5;
        }
    .is-waitlist {
        height: 69px;
    }

    .camp-pricing {
        &:not(:last-child) {
            margin-bottom: 40px;
            padding-bottom: 40px;
            border-bottom: 1px solid $ComplementaryBgTxtDarker;
        }
    }

    .discount-right-tooltiptext-ends {
        /deep/ .with-tooltip .tooltiptext {
            @media screen and (max-width: 991px) {
                right: auto;
                left: auto;
            }
        }
    }

    .discount-right-tooltiptext {
        /deep/ .with-tooltip .tooltiptext {
            @media screen and (max-width: 991px) {
                right: 30px;
                left: auto;
            }
            @media screen and (max-width: 568px) {
                right: 0;
                left: auto;
            }
        }
    }

    .checkbox__input {
        margin-top: -10px;
        margin-bottom: 15px;
        & label {
            font-size: 14px !important;
            font-family: Asap !important;
            color: #888b94 !important;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/main/pages/camp-form/Step4.vue